import * as React from 'react'
import dynamic from 'next/dynamic'

import { HorizontalAlignment } from '@thg-commerce/enterprise-widget-accordion-container'
import { Input, PlatformMessage } from '@thg-commerce/gravity-elements'

import {
  StyledMobileAccordionSearchContainer,
  StyledMobileAccordionSearchContent,
  StyledMobileNotFoundText,
  StyledSearchInputContainer,
} from './styles'
import { AccordionProps } from './HelpCentreCollection'

const SearchIcon = dynamic(
  () => import('@thg-commerce/gravity-icons/src/components/SearchIcon'),
)

interface HelpCenterCollectionSearchProps {
  searchValue: string
  searchText: string
  foundSearchResults: AccordionProps[] | null
  noResultsFound: string
  handleInputOnChange: (inputValue: string) => void
  handleClearInput: () => void
  showNoResultsMessage: boolean
}
export const HelpCenterCollectionSearch = ({
  searchValue,
  searchText,
  foundSearchResults,
  noResultsFound,
  handleInputOnChange,
  handleClearInput,
  showNoResultsMessage,
}: HelpCenterCollectionSearchProps) => {
  return (
    <StyledSearchInputContainer>
      <Input
        valueOverride={searchValue}
        label={searchText}
        labelHidden
        placeholder={searchText}
        autocomplete="off"
        delete
        svgIcon={<SearchIcon />}
        svgIconLeftAlign={false}
        onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
          handleInputOnChange(e.target.value)
        }}
        clearInputValueHandler={handleClearInput}
      />

      {!!foundSearchResults?.length && (
        <StyledMobileAccordionSearchContainer data-testid="mobile-search-content">
          {foundSearchResults.map((accordion, index) => (
            <StyledMobileAccordionSearchContent
              key={`mobile-search-content-${index}`}
              items={accordion.items}
              title={accordion.title}
              alignment={'left' as HorizontalAlignment}
              closeAllOnRender={true}
              contentPadding={true}
            />
          ))}
        </StyledMobileAccordionSearchContainer>
      )}

      {showNoResultsMessage && (
        <StyledMobileNotFoundText>
          <PlatformMessage type="info" text={noResultsFound} />
        </StyledMobileNotFoundText>
      )}
    </StyledSearchInputContainer>
  )
}
